import PropTypes from 'prop-types';

export const MappingTemplate = PropTypes.shape({
  mappingId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});
